import { Injectable } from '@angular/core';
//import {HttpCustomerService} from './httpcustomer.service';
import {MessageclientService} from './messageclient.service';
declare var window;//
@Injectable({
  providedIn: 'root'
})
export class UploadHotService {
  hot_Update: boolean = false;
  constructor(
    //private http:HttpCustomerService,
    private msg:MessageclientService
    ) { }
  eventListener() {
    // this.devicereadyEventListener();
    // this.updateLoadFailedEventListener();
    // this.updateIsReadyToInstallEventListener();
    // this.beforeInstallEventListener();
    // this.updateInstalledEventListener();
    // this.updateInstallFailedEventListener();
    // this.assetsInstallationErrorEventListener();

  }
  /**
   * 监听事件（deviceready），此处执行的是热更新内容
   */
  private devicereadyEventListener(): void{
    let that = this;
    console.log("进入热更新范围0");
    document.addEventListener('deviceready', function () {
      console.log("进入热更新范围1");
          window.chcp.getVersionInfo((error, data) => {
            console.log("进入热更新范围2");
            if (error) {
              console.log(error)
            }
            console.log(data.buildVersion);
            let currentWebVersion: string = data.buildVersion || "";
            let release: any;
            window.chcp.fetchUpdate(that.fetchUpdateCallback.bind(that));
            //that.native.showLoading("正在检测更新...");
            // that.http.get("").toPromise().then((data)=>{
            //   release = data;
            //   let httpCurrentVersion: string = release.release || "";
            //   if (httpCurrentVersion != currentWebVersion) {
            //     window.chcp.fetchUpdate(that.fetchUpdateCallback.bind(that));
            //   }
            // }).catch((error)=>{
            //    console.log(error);
            // });
          });
        
    }, false);
  }
  /**
   * 插件无法从服务器加载更新时发送。错误详细信息附加到事件。用于外壳更新
   */
  private updateLoadFailedEventListener(): void {
    let that = this;
    document.addEventListener('chcp_updateLoadFailed', function (eventData: any) {
      var error = eventData.detail.error;
      if (error && error.code == window.chcp.error.APPLICATION_BUILD_VERSION_TOO_LOW) {
        if (that.hot_Update) {
          var dialogMessage = '发现新版本，即刻下载安装.';
            console.log('发现新版本，即刻下载安装.');
          // if (that.native.isIos) {
          //   window.chcp.requestApplicationUpdate(dialogMessage);
          // } else if (that.native.isAndroid) {
          //   that.native.installApp();
          // }
        }
      }
    }, false);
  }
  /**
   * 当新版本成功加载并准备安装时发送
   */
  private updateIsReadyToInstallEventListener(): void {
    let that = this;
    document.addEventListener('chcp_updateIsReadyToInstall', function () {
      if (that.hot_Update) {
        let wond = window;
        // that.native.hideLoading();
        that.msg.Confirm("发现新文件，是否立即更新?").then(data=>{
          if (data) {
            wond.chcp.installUpdate(function (error: Error) {
             console.log(error);
            });
          }
        });
      }
    }, false);
  }
  /**
   * 在即将安装更新时发送。
   */
  private beforeInstallEventListener(): void {
    document.addEventListener('chcp_beforeInstall', function (error) {
      console.log("即将安装时更新:" + error);
    }, false);
  }
  /**
   * 成功安装更新
   */
   private updateInstalledEventListener(): void {
    document.addEventListener('chcp_updateInstalled', function () {
      console.log("安装完成");
    }, false);
  }
  /**
   * 安装更新失败时
   */
  private updateInstallFailedEventListener(): void {
    document.addEventListener('chcp_updateInstallFailed', function () {
      console.log("安装失败");
    }, false);
  }
  /**
   * 当用户手机存储卡不够用时
   */
  private assetsInstallationErrorEventListener(): void {
    let that = this;
    document.addEventListener('chcp_assetsInstallationError', function () {
      console.log("您的手机存储不足，无法下载更新包");
    }, false);
  }
  // 判断是热更新还是大版本更新
  private fetchUpdateCallback(error, data) {
    let that = this;
    if (!error) {
      this.hot_Update = true;
    }
    else {
      console.log("热更新版本号：" + error.code);
      if (error.code === -3 || error.code === -4) {
        //var dialogMessage = '下载失败，去App store下载最新版';
        //window.chcp.requestApplicationUpdate( dialogMessage );
      }
      //没有可用web更新需要下载.值为 2.
      if (error.code == window.chcp.error.NOTHING_TO_UPDATE) {
        that.hot_Update = true;
      }
      //新的web内容需要新的外壳app. 用户需要更新外壳app.值为 -2.
      if (error.code == window.chcp.error.APPLICATION_BUILD_VERSION_TOO_LOW) {
        that.hot_Update = true;
      }

      //插件正在下载更新时触发. 你必须等待下载完毕. 值为 -14
      if (error.code == window.chcp.error.CANT_INSTALL_WHILE_DOWNLOAD_IN_PROGRESS) {
        console.log(error);
      }
      //安装过程在再执行. 你必须等待安装完毕. 值为 -15.
      if (error.code == window.chcp.error.CANT_DOWNLOAD_UPDATE_WHILE_INSTALLATION_IN_PROGRESS) {
        console.log(error);
      }
      //而安装过程在再执行.值为 - 16
      if (error.code == window.chcp.error.INSTALLATION_ALREADY_IN_PROGRESS) {
        console.log(error);
      }
      // console.log(error.description);
      //error.code=2没有更新，error.code=-17下载正在进行
      //正在下载更新时触发. 值为 -17
      if (error.code == window.chcp.error.DOWNLOAD_ALREADY_IN_PROGRESS) {
        that.hot_Update = true;
      }
      //调用 chcp 方法, 而插件正在拷贝app内置web内容到外部存储时触发. 只可能在app初次启动时发生. 最后这个错误会被移除.值为 -18.
      if (error.code == window.chcp.error.ASSETS_FOLDER_IN_NOT_YET_INSTALLED) {
      }
      // that.native.hideLoading();
    }
  }
}
